import { useTranslation } from 'react-i18next';

import { Card, CardContent, Typography } from '@mui/material';

import type { ConditionTreeGroup } from '../../lib/conditionTree';
import type { ToastSeverity } from '../../lib/useToast';
import { ConditionGroupEditor } from './ConditionGroupEditor';

export interface ConditionTreeEditorProps {
  value: ConditionTreeGroup;
  onChange: (root: ConditionTreeGroup) => void;
  disabled?: boolean;
  onResult: (severity: ToastSeverity, message: string) => void;
}

/** "Conditions" card — the recursive condition-tree editor (plan-011 §8.3-C). */
export function ConditionTreeEditor({ value, onChange, disabled = false, onResult }: ConditionTreeEditorProps) {
  const { t } = useTranslation('promotions');

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
          {t('builder.conditionsCardTitle')}
        </Typography>
        <ConditionGroupEditor
          root={value}
          group={value}
          depth={0}
          disabled={disabled}
          onRootChange={(updater) => onChange(updater(value))}
          onResult={onResult}
        />
      </CardContent>
    </Card>
  );
}
